import { FC } from 'react'
import { Loader2, XCircle } from 'lucide-react'
import { User, EventAttendee } from '@wellesley/openapi'
import { cn } from '@wellesley/ui'
import { EventUser } from '../../EventUser'

type AttendeesListProps = {
  attendees: EventAttendee[]
  loading: boolean
  disabled?: boolean
  onRemove?: (user: User) => void
  loadingAttendeeId?: string
  hideStatusIcons?: boolean
  className?: string
}

const AttendeesList: FC<AttendeesListProps> = ({
  attendees,
  loading,
  disabled,
  onRemove,
  loadingAttendeeId,
  hideStatusIcons,
  className,
}) => {
  const canRemove = !disabled && !!onRemove

  return loading ? (
    <Loader2 className="m-auto animate-spin" size="24" />
  ) : (
    <>
      {attendees.length ? (
        <ul className={cn('flex w-full flex-col gap-xs', className)}>
          {attendees.map((att) => (
            <li
              key={att.uri}
              className="flex items-center gap-xxs overflow-hidden"
            >
              {/*Action available only for resolved attendees*/}
              {att.user ? (
                <>
                  <EventUser
                    user={att.user}
                    status={hideStatusIcons ? undefined : att.status}
                  />
                  {att.user.id === loadingAttendeeId ? (
                    <Loader2 size={16} className="flex-shrink-0 animate-spin" />
                  ) : (
                    canRemove && (
                      <XCircle
                        className="flex-shrink-0 cursor-pointer"
                        size={16}
                        onPointerDown={(e) => e.stopPropagation()}
                        onClick={(e) => {
                          e.stopPropagation()
                          onRemove(att.user!)
                        }}
                      />
                    )
                  )}
                </>
              ) : (
                <EventUser
                  uri={att.uri}
                  status={hideStatusIcons ? undefined : att.status}
                />
              )}
            </li>
          ))}
        </ul>
      ) : (
        <span className="text-base font-normal text-gray-500">
          {disabled ? 'No attendees' : 'Select attendees'}
        </span>
      )}
    </>
  )
}

export default AttendeesList
